<template>
  <v-card outlined>
    <v-card-text style="padding: 16px 20px">
      <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap">
        <!-- Titre -->
        <div style="display: flex; align-items: center; gap: 10px; flex-shrink: 0">
          <v-icon :color="couleurJauge">mdi-target</v-icon>
          <span style="font-size: 16px; font-weight: 700; color: #444">
            Objectif commercial SEGUR V2
          </span>
        </div>

        <!-- Barre de progression : prend la largeur restante -->
        <div style="flex: 1; min-width: 240px">
          <v-progress-linear
            :value="pourcentage"
            :color="couleurJauge"
            background-color="#e0e0e0"
            height="20"
            rounded
            :aria-label="ariaLabel"
          />
        </div>

        <!-- Valeurs alignees a droite -->
        <div
          style="font-size: 16px; color: #666; flex-shrink: 0; text-align: right; min-width: 260px"
        >
          <span style="font-weight: 700; color: #222">{{ formatEur(caEngage) }}</span>
          <span style="margin: 0 6px; color: #aaa">/</span>
          <span style="color: #777">{{ formatEur(objectif) }}</span>
          <span :style="{ color: couleurJauge, fontWeight: 700, marginLeft: '12px', fontSize: '18px' }">
            {{ pourcentage }} %
          </span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "GaugeSegurCA",

  props: {
    // CA engage en EUR HT (somme des BDC V2 tous etats confondus)
    caEngage: {
      type: Number,
      required: true,
    },
    // Objectif commercial en EUR HT
    objectif: {
      type: Number,
      required: true,
    },
  },

  computed: {
    // Pourcentage borne 0-100, 1 decimale.
    pourcentage() {
      if (!this.objectif) return 0;
      const p = (this.caEngage / this.objectif) * 100;
      return Math.min(100, Math.round(p * 10) / 10);
    },

    // Couleur selon palier : rouge < 33%, orange 33-66%, vert >= 66%.
    couleurJauge() {
      const theme = this.$vuetify?.theme?.currentTheme || {};
      if (this.pourcentage >= 66) return theme.success || "#4caf50";
      if (this.pourcentage >= 33) return theme.warning || "#ff9800";
      return theme.error || "#f44336";
    },

    ariaLabel() {
      return `Progression vers l'objectif commercial : ${this.formatEur(this.caEngage)} engages sur ${this.formatEur(this.objectif)}, soit ${this.pourcentage} pour cent.`;
    },
  },

  methods: {
    // Format EUR avec separateur milliers fr-FR, sans decimales (objectif commercial = montants ronds)
    formatEur(valeur) {
      if (typeof valeur !== "number") return "-";
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
      }).format(valeur);
    },
  },
};
</script>
